import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

import styles from './BackHeader.module.css';
export const BackHeader = ({
  title,
  headerOnPress,
}: {
  title: string;
  headerOnPress: () => void;
}) => {
  return (
    <div className={styles.backHeader}>
      <button className={styles.backHeaderButton} onClick={headerOnPress}>
        <ChevronLeftIcon className={styles.backHeaderLeftChevron} />
        <span className={styles.backHeaderText}>{title}</span>
      </button>
    </div>
  );
};
